import { TaskListItem, TaskControlsAction } from '../../types/tasks.types';

export const TaskSimpleButtons = function(props: {
	tasksList: TaskListItem[],
	actionClick: (action: TaskControlsAction, taskTitle: string) => void
}) {
	return props.tasksList.map((task, index) => {
		let displayTitle = task.taskTitle.replace(/_/g, ' ');
		return (
			<button
				key={task.taskTitle+'-simple-'+index}
				className='teachers-button teachers-button-light teachers-taskslist-simplebutton'
				onClick={() => {props.actionClick(TaskControlsAction.View, task.taskTitle);}}>
				{displayTitle}
			</button>
		);
	});
};
